module.exports = __webpack_public_path__ + "static/media/dragfile.d4549b29.svg";